// Generated by ReScript, PLEASE EDIT WITH CARE


function notAsked() {
  return "NotAsked";
}

function loading() {
  return "Loading";
}

function reloading(data) {
  return {
    TAG: "Reloading",
    _0: data
  };
}

function done(data) {
  return {
    TAG: "Done",
    _0: data
  };
}

function isInitialLoading(asyncData) {
  if (typeof asyncData !== "object") {
    return asyncData === "Loading";
  } else {
    return false;
  }
}

function isReloading(asyncData) {
  if (typeof asyncData !== "object") {
    return false;
  } else {
    return asyncData.TAG === "Reloading";
  }
}

function isNotAsked(asyncData) {
  if (typeof asyncData !== "object") {
    return asyncData === "NotAsked";
  } else {
    return false;
  }
}

function isBusy(asyncData) {
  if (typeof asyncData !== "object") {
    return asyncData !== "NotAsked";
  } else {
    return asyncData.TAG === "Reloading";
  }
}

function isIdle(asyncData) {
  if (typeof asyncData !== "object") {
    return asyncData === "NotAsked";
  } else {
    return asyncData.TAG !== "Reloading";
  }
}

function isDone(asyncData) {
  if (typeof asyncData !== "object") {
    return false;
  } else {
    return asyncData.TAG === "Done";
  }
}

function toBusy(asyncData) {
  if (typeof asyncData !== "object") {
    if (asyncData === "NotAsked") {
      return "Loading";
    } else {
      return asyncData;
    }
  } else if (asyncData.TAG === "Reloading") {
    return asyncData;
  } else {
    return {
      TAG: "Reloading",
      _0: asyncData._0
    };
  }
}

function map(asyncResult, transform) {
  if (typeof asyncResult !== "object") {
    if (asyncResult === "NotAsked") {
      return "NotAsked";
    } else {
      return "Loading";
    }
  } else if (asyncResult.TAG === "Reloading") {
    return {
      TAG: "Reloading",
      _0: transform(asyncResult._0)
    };
  } else {
    return {
      TAG: "Done",
      _0: transform(asyncResult._0)
    };
  }
}

function flatMap(asyncResult, transform) {
  if (typeof asyncResult !== "object") {
    if (asyncResult === "NotAsked") {
      return "NotAsked";
    } else {
      return "Loading";
    }
  } else {
    return transform(asyncResult._0);
  }
}

function mapWithDefault(asyncResult, defaultValue, transform) {
  if (typeof asyncResult !== "object") {
    return defaultValue;
  } else {
    return transform(asyncResult._0);
  }
}

function getWithDefault(asyncResult, defaultValue) {
  if (typeof asyncResult !== "object") {
    return defaultValue;
  } else {
    return asyncResult._0;
  }
}

export {
  notAsked,
  loading,
  reloading,
  done,
  isInitialLoading,
  isReloading,
  isNotAsked,
  isBusy,
  isDone,
  isIdle,
  toBusy,
  map,
  flatMap,
  mapWithDefault,
  getWithDefault,
}
/* No side effect */
